(function ($) {
    // Default setting for adding an uid to the layer.
    // const GTM_DATALAYER_ADDUID = true;
    const GTM_DATALAYER_ADDUID = false;

    // Default setting for showing the datalayer in the console on push.
    // const GTM_DATALAYER_VERBOSE = true;
    const GTM_DATALAYER_VERBOSE = false;
    // Usage: $.fn.gtmDatalayer(#DATALAYER#);

    // Initialize datalayer.
    window.dataLayer = window.dataLayer || [];

    /**
     * Initialize: $.fn.gtmDatalayer(dataLayer);
     */

    /**
     *
     * @param dataLayer
     * @param addUid
     * @param verbose
     * @returns {gtmDatalayer}
     */
    let gtmDatalayer = function (dataLayer, addUid, verbose) {
        /**
         *
         * @returns {dataLayer}
         */
        this.getDatalayer = function () {
            let dataLayer = JSON.parse(JSON.stringify(this.obj));
            if (this.addUid) {
                dataLayer.uid = window.uuid('gtmDatalayer');
            }
            return dataLayer;
        }

        /**
         * Push the layer to the Google Tag Manager.
         */
        this.push = function () {
            let dataLayer = this.getDatalayer();
            if (this.verbose) {
                console.log('gtmDatalayer.push', dataLayer);
            }
            window.dataLayer.push(dataLayer);
        }

        /**
         *
         * @param dataLayer
         */
        this.set = function (dataLayer) {
            this.obj = dataLayer;
        }

        /**
         *
         * @param parameter
         * @param val
         */
        this.setParameter = function (parameter, val) {
            this.obj[parameter] = val;
        }

        /**
         *
         * @param dataLayer
         * @param addUid
         * @param verbose
         */
        this.init = function (dataLayer, addUid, verbose) {
            this.set(dataLayer);
            this.addUid = addUid;
            this.verbose = verbose;
            this.push();
        }

        this.init(dataLayer, addUid, verbose);

        return this;
    };
    // };

    /**
     * @param {*} dataLayer
     * @param addUid
     * @param verbose
     */
    $.fn.gtmDatalayer = function (dataLayer, addUid = null, verbose = null) {
        let args = [
            dataLayer,
            ((addUid !== null) ? addUid : GTM_DATALAYER_ADDUID),
            ((verbose !== null) ? verbose : GTM_DATALAYER_VERBOSE)
        ];
        return gtmDatalayer.apply({}, args);
    };

})(jQuery);
